export enum DATA_QA {
  ROOT = 'csv-field-mapper',
  ROW = 'csv-field-mapper__row',
}
